import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as base64 from 'base-64';
import { RadioButtonComponent } from '@syncfusion/ej2-react-buttons';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Modal, Button } from 'react-bootstrap';
import i18n from 'i18next';
import { clearUserCredentials } from '../../../actions/application';
import { lexonCredentialsClear } from '../../../actions/lexon';
import { currentUserCredentialsClear } from '../../../actions/user';
import { removeState } from '../../../services/state';

class AccountUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedAccount: null,
      selectedEmailAccount: ''
    };

    this._handleOnClick = this._handleOnClick.bind(this);
  }

  _handleOnClick(provider, account) {
    const { userId, lexonToken } = this.props.lexon;
    let urlRedirect;

    switch (provider) {
      case 'GOOGLE':
        urlRedirect = lexonToken
          ? `${window.URL_MF_GOOGLE}/access/${lexonToken}/?prov=GO0&email=${account}`
          : `${window.URL_MF_GOOGLE}/user/GO0${userId}`;
        break;

      case 'OUTLOOK':
        urlRedirect = lexonToken
          ? `${window.URL_MF_OUTLOOK}/access/${lexonToken}/?prov=OU0`
          : `${window.URL_MF_OUTLOOK}/user/OU0${userId}`;
        break;

      default:
        urlRedirect = lexonToken
          ? `${window.URL_MF_IMAP}/access/${lexonToken}/?prov=IM0&account=${base64.encode(
              account
            )}`
          : `${window.URL_MF_IMAP}/user/IM0${userId}?account=${base64.encode(
              account
            )}`;
        break;
    }

    removeState();
    this.props.logout();
    window.location.replace(urlRedirect);
  }

  getImage(provider) {
    switch (provider) {
      case 'GOOGLE':
        return '/assets/images/google.svg';
      case 'OUTLOOK':
        return '/assets/images/microsoft.svg';
      default:
        return '/assets/images/imap.svg';
    }
  }

  selectAccountItem = account => {
    this.setState({
      selectedAccount: account,
      selectedEmailAccount: account.email
    });
  };

  accountItemRender() {
    const { accSelectorList } = this.props;
    const { selectedEmailAccount } = this.state;
    return (
      <ul className="list-account-container">
        {accSelectorList.map((account, i) => (
          <React.Fragment key={i}>
            <li
              className={
                selectedEmailAccount === account.email
                  ? 'item-user-account account-active'
                  : 'item-user-account'
              }
            >
              <div className="d-flex align-items-center">
                <RadioButtonComponent
                  name="account-item-user-radio"
                  change={() => this.selectAccountItem(account)}
                />
                <span>
                  <img
                    className="img-user-account"
                    src={this.getImage(account.provider)}
                    alt={account.provider}
                  />
                </span>
                <span className="ml-2 item-user-account-text">
                  {account.email}
                </span>
              </div>
            </li>
          </React.Fragment>
        ))}
      </ul>
    );
  }

  render() {
    const { showAccountChange, handleCloseAccountModal } = this.props;
    const { selectedEmailAccount, selectedAccount } = this.state;
    return (
      <>
        <Modal
          show={showAccountChange}
          onHide={() => {
            handleCloseAccountModal();
            this.setState({ selectedEmailAccount: '' });
          }}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="account-change-modal"
        >
          <Modal.Header>
            <div className="account-change-modal-header">
              <Modal.Title>{i18n.t('menu-user.change-account')}</Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body>
            <PerfectScrollbar
              options={{ suppressScrollX: true }}
              className="modal-body-scrollbar"
            >
              {this.accountItemRender()}
            </PerfectScrollbar>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-end modal-btn-container">
              <Button
                className="font-weight-bold btn-outline-primary"
                title={i18n.t('eventtype.cancel')}
                color="secondary"
                onClick={() => {
                  handleCloseAccountModal();
                  this.setState({ selectedEmailAccount: '' });
                }}
              >
                {i18n.t('eventtype.cancel')}
              </Button>
              <Button
                className="mr-auto font-weight-bold ml-1"
                color="primary"
                title={i18n.t('menu-user.save')}
                disabled={selectedEmailAccount === ''}
                onClick={() => {
                  this._handleOnClick(
                    selectedAccount.provider,
                    selectedAccount.email
                  );
                }}
              >
                {i18n.t('menu-user.save')}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

AccountUser.propTypes = {
  account: PropTypes.object
};

const mapStateToProps = state => ({
  lexon: state.lexon
});

const mapDispatchToProps = dispatch => ({
  logout: () => {
    dispatch(clearUserCredentials());
    dispatch(lexonCredentialsClear());
    dispatch(currentUserCredentialsClear());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountUser);
